import { render, staticRenderFns } from "./ImgStatic.vue?vue&type=template&id=2fb6305a&scoped=true&"
import script from "./ImgStatic.vue?vue&type=script&lang=js&"
export * from "./ImgStatic.vue?vue&type=script&lang=js&"
import style0 from "./ImgStatic.vue?vue&type=style&index=0&id=2fb6305a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb6305a",
  null
  
)

export default component.exports